export enum SellerIDsEnum {
  SHOPWARE = 'f37e378c-e188-46ec-85f6-0f3f0a0bb98c',
  HEPSIBURADA = 'b457d78a-d9b5-4098-b8f4-cc0f25e3b2f2',
  RIBAMUNDO = '902b51ac-591e-41dc-ae58-36b5209e5713',
  ACTION = '902b51ac-591e-41dc-ae58-558310111992',
  KOMPJUTRONIK = '57b490f-eb88-a413-791b-edfa178d8c799',
  GRIFFATI = '5a258eaa-c8b3-11ed-942a-5a781636e1fd',
  BRANDS_GET_WAY = '484ee6c4-97bd-46af-97a6-68401208c272',
}
